import { DKDialog } from "../common/DKDialog";
import React, { ChangeEvent } from "react";
import DKFormContainer from "../common/forms/formContainer/DKFormContainer";
import DKFormTextInput from "../common/widgets/formVariablesWidget/DKFormTextInput";

type CreateOrganizationModalProps = {
  isOpen: boolean;
  title: string;
  contentText: string;
  dataTestIdModifier: string;
  isSaveButtonDisabled: boolean;
  nameLabel?: string;
  emailLabel?: string;
  firstNameLabel?: string;
  lastNameLabel?: string;
  nameErrorLabel?: string;
  emailErrorLabel?: string;
  firstNameErrorLabel?: string;
  lastNameErrorLabel?: string;
  onCancel: () => void;
  onSave: () => void;
  onFieldChange: (event: ChangeEvent<HTMLInputElement>) => void;
};
export const CreateOrganizationModal = (
  props: CreateOrganizationModalProps
) => {
  const {
    isOpen,
    title,
    contentText,
    dataTestIdModifier,
    isSaveButtonDisabled,
    nameLabel,
    emailLabel,
    firstNameLabel,
    lastNameLabel,
    nameErrorLabel,
    emailErrorLabel,
    firstNameErrorLabel,
    lastNameErrorLabel,
    onCancel,
    onSave,
    onFieldChange,
  } = props;
  return (
    <DKDialog
      open={isOpen}
      title={title}
      contentText={contentText}
      actionButtons={[
        {
          label: "Cancel",
          dataTestId: `cancel-${dataTestIdModifier}`,
          onClick: onCancel,
        },
        {
          label: "Save",
          primary: true,
          dataTestId: `save-${dataTestIdModifier}`,
          disabled: isSaveButtonDisabled,
          onClick: onSave,
        },
      ]}
    >
      <DKFormContainer>
        <DKFormTextInput
          required={true}
          name="name"
          customErrorLabel={nameErrorLabel}
          dataTestId={`${dataTestIdModifier}-name`}
          label={nameLabel ? nameLabel : "Name"}
          value={undefined}
          onChange={onFieldChange}
        />
        <DKFormTextInput
          required={true}
          name="email"
          customErrorLabel={emailErrorLabel}
          dataTestId={`${dataTestIdModifier}-email`}
          label={emailLabel ? emailLabel : "Email"}
          value={undefined}
          onChange={onFieldChange}
        />
        <DKFormTextInput
          required={true}
          name="firstName"
          customErrorLabel={firstNameErrorLabel}
          dataTestId={`${dataTestIdModifier}-firstName`}
          label={firstNameLabel ? firstNameLabel : "First Name"}
          value={undefined}
          onChange={onFieldChange}
        />
        <DKFormTextInput
          required={true}
          name="lastName"
          customErrorLabel={lastNameErrorLabel}
          dataTestId={`${dataTestIdModifier}-lastName`}
          label={lastNameLabel ? lastNameLabel : "Last Name"}
          value={undefined}
          onChange={onFieldChange}
        />
      </DKFormContainer>
    </DKDialog>
  );
};
